import { Billing } from '@nemuru-eng/js-api-client';

import { BillingForm } from '@/components/modules/ShippingAndBilling/_shared/components/BillingDetails/components/BillingForm';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { PendingDataType } from '@/config/types';

export const BillingDetails = ({ billing }: { billing: Billing | null }) => {
  return (
    <SubSectionWrapper title={'BILLING_ADDRESS'}>
      {billing ? (
        <>
          <BillingForm billing={billing} />
        </>
      ) : (
        <PendingDataWarning type={PendingDataType.ADDRESS} />
      )}
    </SubSectionWrapper>
  );
};
